import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons

// style imports
import { LinkButtonCtaStyled } from './styles';

export default () => (
  <SectionContainer
    id='variable-universal-life-insurance-product-intro'
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='intro-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        medium={8}
        align='center'>
        <Typography
          component='h2'
          nextElement='typography'>
          What is variable universal life <WidowBlock>insurance (VUL)&#63;</WidowBlock>
        </Typography>
      </Col>
      <Col
        medium={8}
        align='center'>
        <Typography
          align='left'
          nextElement='button'>
          Variable universal life gives you the protection of a generally tax&#45;free death benefit along with the flexibility to customize your policy as your life and needs change. If you&#39;re interested in growing your wealth, VUL might be a smart move. That&#39;s because it gives you the opportunity to build even more cash value than you could with other types of permanent life insurance, potentially leading to a higher death benefit. However, it&#39;s important to know that since your policy&#39;s cash value is invested in the market, it can go up or down in value based on market volatility.
        </Typography>
        <LinkButtonCtaStyled
          variant='buttonLinkPrimary'
          themeType='lightTheme'
          id='variable-universal-life-insurance-product-intro-cta-fafa'
          ariaLabel='Get variable universal life insurance with a financial advisor'
          linkUrl='/find-a-financial-advisor/'>
          Get started
        </LinkButtonCtaStyled>
      </Col>
    </Row>
  </SectionContainer>
);
